import request from 'catalog/utils/axios'

export type ProductService = {
  acceptanceTerms: {
    message: string
    title: string
  }[]
  id: number
  name: string
  price: {
    from: number
    to: number
  }
  serviceBankName: string
  unit: string
}

export type ProductVariant = {
  name: string
  characteristicId: string
  types: {
    id: number
    label: string
    url: string
    stock: number
  }[]
}

export type GetProductVariantsData = ProductVariant[]

type GetProductVariantsResponse = {
  data: GetProductVariantsData
}

export const getProductServices = async (
  productId: number,
  regionId: string
) => {
  const response = await request
    .get<{ data: ProductService[] }>(
      `/api/v3/crosses/${productId}/services?regionId=${regionId}`
    )
    .then(({ data }) => data.data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const getProductVariants = async (productId: number) =>
  await request
    .get<GetProductVariantsResponse>(`/api/v3/products/${productId}/variants`)
    .then(({ data }) => data.data)
    .catch(err => {
      throw err.response
    })
